import { render } from "./ChannelGoalProgress.vue?vue&type=template&id=bb1037a6"
import script from "./ChannelGoalProgress.vue?vue&type=script&lang=ts"
export * from "./ChannelGoalProgress.vue?vue&type=script&lang=ts"
script.render = render

export default script